/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Directive, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

/**
  * Simple directive for phone inputs
  */
@Directive({ selector: '[russianPhoneMask]' })
export class RussianPhoneMaskDirective {

  constructor(public ngControl: NgControl) { }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event, false);
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event) {
    this.onInputChange(event.target.value, true);
  }

   /**
    * Masks the phone input value like +0 (000) 000-00-00
    * @param event Getting user input from the $event object
    * @param backspace boolean param if the backspace has been hit
    * {@link https://angular.io/guide/user-input#get-user-input-from-the-event-object}
    */
  onInputChange(event, backspace): void {

    let newVal = event.replace(/\D/g, '');

    if (backspace && newVal.length <= 9) {
      newVal = newVal.substring(0, newVal.length - 1);
    }
    if (newVal.length === 0) {
      newVal = '';
    } else if (newVal.length <= 1) {
      newVal = newVal.replace(/^(\d?)/, '+$1');
    } else if (newVal.length <= 4) {
      newVal = newVal.replace(/^(\d?)(\d{0,3})/, '+$1 ($2)');
    } else if (newVal.length <= 7) {
      newVal = newVal.replace(/^(\d?)(\d{0,3})(\d{0,3})/, '+$1 ($2) $3');
    } else if (newVal.length <= 9) {
      newVal = newVal.replace(/^(\d?)(\d{0,3})(\d{0,3})(\d{0,2})/, '+$1 ($2) $3-$4');
    } else if (newVal.length <= 11) {
      newVal = newVal.replace(/^(\d?)(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/, '+$1 ($2) $3-$4-$5');
    } else {
      newVal = newVal.substring(0, 11);
      newVal = newVal.replace(/^(\d?)(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/, '+$1 ($2) $3-$4-$5');
    }

    newVal = newVal.replace(/\+\d/, '+7');

    this.ngControl.valueAccessor.writeValue(newVal);
  }
}
